import React, { memo, useState } from 'react'
import Modal from './Modal'
import { newProduct } from '../../functions/stateList'
import CarModalInput from '../inputs/CarModalInput'
import ModalSubmitFormButton from '../buttons/ModalSubmitFormButton'
import { addProductSubmitHandler } from '../../functions/AddProductModalSubmit'
import CarModalSelect from '../inputs/CarModalSelect'

function AddProductModal({ category, products, setProducts, products_types, setShowModal }) {
  const [inputs, setInputs] = useState({
    ...newProduct,
  })

  const [error, setError] = useState({
    ...newProduct,
  })

  const [isSubmit, setIsSubmit] = useState(false)

  const inputHandler = (e) => {
    let name = e.target.name
    let value = e.target.value

    setInputs({
      ...inputs,
      [name]: value,
    })

    setError({
      ...error,
      [name]: '',
    })
  }

  const formHandler = async (e) => {
    e.preventDefault()
    setIsSubmit(true)
    await addProductSubmitHandler(
      category,
      setIsSubmit,
      inputs,
      setError,
      error,
      products_types,
      products,
      setProducts,
      setShowModal
    )
  }
  return (
    <Modal>
      <form onSubmit={formHandler}>
        {/*header*/}
        <div className="p-3 md:p-5">
          <h3 className="text-xl md:text-2xl font-semibold text-center dark:text-slate-200">
            افزودن محصول - {category === 'خدمات تعویض روغن' ? 'تعویض روغن' : 'خدمات مکانیکی'}
          </h3>
        </div>

        {/*body*/}
        <div className="relative p-6 flex flex-col">
          <CarModalInput
            title={'نام محصول'}
            type={'text'}
            isSubmit={isSubmit}
            name={'name'}
            value={inputs?.name}
            inputHandler={inputHandler}
            error={error}
          />
          <CarModalSelect
            title={'دسته بندی محصول'}
            isSubmit={isSubmit}
            name={'product'}
            value={inputs?.product}
            inputHandler={inputHandler}
            error={error}
            list={products_types}
            text_key={'product_category'}
          />
        </div>

        {/*footer*/}
        <ModalSubmitFormButton setShowModal={setShowModal} isSubmit={isSubmit} />
      </form>
    </Modal>
  )
}

export default memo(AddProductModal)
